import { render } from "./StockAlertReport.vue?vue&type=template&id=3c3a8d84&ts=true"
import script from "./StockAlertReport.vue?vue&type=script&lang=ts"
export * from "./StockAlertReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__